// AI Generated Component
import { Component, OnInit, OnDestroy } from '@angular/core';
import { StateService } from '@uirouter/core';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PolicyHelperService } from '@client/app/blocks/helpers/policy-helper/policy.helper.service';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { PolicyService } from '@client/app/services/entities/policy/policy.service';
import { PolicyTableService } from '@client/app/modules/policies/services/policy-table.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { FormGlobalPolicyComponent } from '@client/app/forms/global-policy/form-global-policy.component';
import {
    PagesPolicyDialogPagesComponent,
} from '@client/app/pages/policy/dialogs/pages/pages-policy-dialog-pages.component';
import {
    PagesPolicyDialogLinksComponent,
} from '@client/app/pages/policy/dialogs/links/pages-policy-dialog-links.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-policy-policies',
    template: `
<page-header
  [icon]="['POLICIES', 'POLICIES'] | monIcons"
  [header]="'Policies List' | translate"
  [subHeader]="subheaderTranslation">
  <page-header-content>
    <div class="row">
      <div class="col-48 text-right">
        <a uiSref="base.customer.global.policy.dashboard"
          class="mr-2"
          [ngbTooltip]="'Go to Global Policy List' | translate"
          [triggers]="'focus hover'"
          [attr.title]="'Go to Global Policy List' | translate"
          monEventTrigger="actionTrigger"
          [monEventParams]="{action:'go-to-global-policy-dashboard', from: 'domain-policy-policy-list'}">
          <span class="icon fas fa-gavel" aria-hidden="true"></span>
          <span translate>Global Policy List</span>
        </a>
        <button
          class="btn btn-border-radius btn-secondary"
          type="button"
          (click)="openPolicyForm()"
          monEventTrigger="actionTrigger"
          [monEventParams]="{action:'before-policy-create'}"
          translate
        >
          Add new policy
        </button>
      </div>
    </div>
  </page-header-content>
</page-header>
<mon-tabs
  [options]="tabs"
  [(status)]="tab"
  (onSearch)="onSearch($event)"
  (onStatus)="onStatus($event)"
  [search]="search"
  [showSearch]="true"
  [maxOptionsDisplay]="5"
  [showFiltersBtn]="showFilters"
  [(isFiltersOpen)]="isFiltersOpen">
  <csv-export-button category="policies"></csv-export-button>
</mon-tabs>
<div class="card panel-monsido-card">
  <div class="card-body">
    <table-container
      [disablePagination]="false"
      [noResultMessage]="'No policies found' | translate"
      [collection]="policies"
      (onPageChange)="onPageChange($event)"
      (onPerPageChange)="onPageSizeChange($event)"
      [progress]="progress">
      <table-container-top>
        <div class="mb-4 merge-r-16 merge-l-16 merge-t-10" *ngIf="isFiltersOpen">
          <table-filters [(open)]="isFiltersOpen"
                         [(ngModel)]="filters"
                         name="filters"
                         [filters]="availableFilters"
                         (onChanges)="onFiltersChanges($event)">
          </table-filters>
        </div>
      </table-container-top>
      <table class="table table-hover table-with-labels">
        <thead>
          <tr>
            <th class="col-3"></th>
            <th monTableSort
                monSortBy="name"
                [monSortDirection]="currentSort.direction"
                [monCurrentlySortedBy]="currentSort.by"
                (monOnSorted)="onMonTableSort($event)">
              {{ 'Title' | translate }}
            </th>
            <th class="col-6 text-right" translate>Actions</th>
            <th class="col-9 text-right"
                monTableSort
                monSortBy="pages_count"
                [monSortDirection]="currentSort.direction"
                [monCurrentlySortedBy]="currentSort.by"
                (monOnSorted)="onMonTableSort($event)">
                {{ 'Compliance' | translate }}
            </th>
            <th class="col-6 text-right" translate>Policy Hits</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let policy of policies; trackBy: trackByPolicyId">
            <td class="text-v-middle text-center">
              <span *ngIf="policy.state === 'running'"
                [attr.aria-label]="'Policy Running' | translate">
                <span class="fas fa-2x fa-spinner fa-spin">
                </span>
              </span>
              <mon-table-policy-type
                *ngIf="policy.state !== 'running'"
                class="inline-block"
                [passed]="policy.matches_count === 0 && policyScanValid(policy)"
                [tooltip]="getTooltipMessageForType(policy)"
                [target]="getPolicyTarget(policy)">
              </mon-table-policy-type>
            </td>
            <td class="text-v-middle">
              <policy-information [policy]="policy" class="inline-block">
              </policy-information>
              <label-table *ngIf="showLabels"
                           [assignedLabels]="policy.labels"
                           [existingLabels]="labels"
                           (getLabels)="getLabels()"
                           (onUpdateLabel)="updatePolicy(policy)">
              </label-table>
            </td>
            <td class="text-v-middle text-right">
              <mon-action-menu [monActionMenuItems]="policy.dropdown">
                <span translate>Action</span>
              </mon-action-menu>
            </td>
            <td class="text-right text-v-middle" *ngIf="policy.state !== 'running'">
              <mon-spinner [progress]="setupProgress">
                <table-css-compliance
                  class="inline-block"
                  [totalCount]="htmlCount"
                  [errorCount]="policy.pages_count"
                  *ngIf="policy.subject === 'page_html' && hasRun(policy) && policyScanValid(policy)">
                </table-css-compliance>

                <table-css-compliance
                  class="inline-block"
                  [totalCount]="allPagesCount"
                  [errorCount]="policy.pages_count"
                  *ngIf="policy.subject === 'page' && hasRun(policy) && policyScanValid(policy)">
                </table-css-compliance>

                <table-css-compliance
                  class="inline-block"
                  [totalCount]="htmlCount"
                  [errorCount]="policy.pages_count"
                  *ngIf="policy.subject === 'page_html_text' && hasRun(policy) && policyScanValid(policy)">
                </table-css-compliance>

                <table-css-compliance
                  class="inline-block"
                  [totalCount]="documentCount"
                  [errorCount]="policy.pages_count"
                  *ngIf="policy.subject === 'page_document' && hasRun(policy) && policyScanValid(policy)">
                </table-css-compliance>

                <table-css-compliance
                  class="inline-block"
                  [totalCount]="linksCount"
                  [errorCount]="policy.links_count"
                  *ngIf="policy.subject === 'link' && hasRun(policy) && policyScanValid(policy)">
                </table-css-compliance>

                <span *ngIf="policy.subject !== 'link' && !hasRun(policy) && policyScanValid(policy)"
                      class="text-grey text-nowrap"
                      translate>
                  No run present
                </span>
                <button class="btn btn-border-radius btn-secondary"
                        type="button"
                        (monModalConfirmAction)="runPolicy(policy)"
                        [monModalConfirm]="'Are you sure you want to run the policy <strong>' + policy.name + '</strong>?' | translate"
                        *ngIf="policy.state !== 'queued' && !policyScanValid(policy)"
                        [ngbTooltip]="'Policy Scan is no longer valid. Press Run Policy to update Policy Scan details' | translate"
                        [triggers]="'focus hover'"
                        monEventTrigger="actionTrigger"
                        [monEventParams]="{action:'policy-run', params: {name: policy.name}}"
                        translate>
                  Run policy
                </button>
              </mon-spinner>
            </td>
            <td class="text-right text-v-middle" *ngIf="policy.state !== 'running'">
              <pages-button (callback)="openPagesDialog(policy)"
                            [(ngModel)]="policy.matches_count"
                            name="policyMatchesCount"
                            [text]="'Hit' | translate"
                            [textPlural]="'Hits' | translate"
                            [monAriaLabel]="'Pages with policy matches' | translate"
                            *ngIf="policy.subject !== 'link' && policy.matches_count > 0">
              </pages-button>
              <pages-button (callback)="openLinksDialog(policy)"
                            [(ngModel)]="policy.matches_count"
                            name="policyLinksMatchesCount"
                            [text]="'Hit' | translate"
                            [textPlural]="'Hits' | translate"
                            [monAriaLabel]="'Links with policy matches' | translate"
                            *ngIf="policy.subject === 'link' && policy.matches_count > 0">
              </pages-button>
              <span *ngIf="policy.matches_count === 0" class="text-light-green text-nowrap" translate>
                No hits found
              </span>
            </td>
            <td class="text-v-middle text-secondary-4 text-right" *ngIf="policy.state === 'running'" colspan="2" translate>
              Policy scan in progress
            </td>
          </tr>
        </tbody>
      </table>
    </table-container>
  </div>
</div>
    `,
    standalone: false,
})
export class PolicyPoliciesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    openSelectedPolicy: any = null;
    destroyed: boolean = false;
    allPagesCount: number = 0;
    documentCount: number = 0;
    pagesCount: number = 0;
    pdfCount: number = 0;
    htmlCount: number = 0;
    complianceLabels: string[] = ['errors', 'pages_count'];
    policies: any[] = [];
    tab: any = null;
    timerPromise: number | null = null;
    policyScheduled: any = null;
    subheaderTranslation: string = '';
    override isAdmin: boolean = false;
    setupProgress: any;
    tabs: any[] = [];
    linksCount: number = 0;
    progress: any;

    constructor (
        private policyRepoService: PolicyRepoService,
        private translateService: TranslateService,
        private policyHelperService: PolicyHelperService,
        private pageRepoService: PageRepoService,
        private linksRepoService: LinksRepoService,
        private policyService: PolicyService,
        private policyTableService: PolicyTableService,
        private paramService: ParamService,
        private monModalService: MonModalService,
        private stateService: StateService,
    ) {
        super({ table: true, labels: true });
    }

    ngOnDestroy (): void {
        this.onDestroy();
    }

    ngOnInit (): void {
        this.openSelectedPolicy = null;
        this.destroyed = false;
        this.allPagesCount = 0;
        this.documentCount = 0;
        this.pagesCount = 0;
        this.pdfCount = 0;
        this.htmlCount = 0;
        this.complianceLabels = ['errors', 'pages_count'];
        this.policies = [];
        this.tab = this.stateService.params.tab ? this.stateService.params.tab : '';
        this.timerPromise = null;
        this.policyScheduled = null;
        this.currentSort = {
            by: 'matches_count',
            direction: 'desc',
        };
        this.subheaderTranslation = '';

        this.isAdmin = this.sessionService.hasRole('customer_admin');
        const promises = [
            this.getPagesCount(),
            this.getPagesCount('pdf'),
            this.getPagesCount('html'),
            this.getPagesCount('document'),
            this.getLinksCount(),
        ];
        this.setupProgress = Promise.all(promises).then((values: any[]) => {
            this.allPagesCount = parseInt(values[0].total);
            this.pdfCount = parseInt(values[1].total);
            this.htmlCount = parseInt(values[2].total);
            this.documentCount = parseInt(values[3].total);
            this.linksCount = parseInt(values[4].total);
        }, () => {});
        this.tabs = this.policyTableService.getTabs(false);
        this.setupCustomFilters();
        this.loadLocations();
        this.onStatus(this.tab); // Starts getPolicies
    }

    getTooltipMessageForType (type: any): string {
        return this.policyHelperService.getTooltipMessageForType(type) || '';
    }

    onDestroy (): void {
        this.destroyed = true;
        this.destroyTimer();
    }

    loadLocations (): void {
        const params = location.search;
        const urlParams = new URLSearchParams(params);

        const searchParam = urlParams.get('search');
        if (searchParam && searchParam.length > 0) {
            this.search = searchParam;
        }
        const policyId = urlParams.get('policy_id');
        if (policyId && Number.parseInt(policyId, 10) > 0) {
            this.openSelectedPolicy = policyId;
        }
    }

    destroyTimer (): void {
        if (this.timerPromise !== null) {
            clearTimeout(this.timerPromise);
            this.timerPromise = null;
        }
    }

    setupCustomFilters (): void {
        this.availableFilters.scheduled = [
            {
                name: this.translateService.getString('Scheduled'),
                value: true,
            },
            {
                name: this.translateService.getString('Not scheduled'),
                value: false,
            },
        ];
        this.filters.scheduled = [];
    }

    getPagesCount (type?: string): Promise<any> {
        const params: any = {
            page: 1,
            page_size: 1,
            type: type,
        };
        return this.pageRepoService.getAll(params).then(
            (res: any) => {
                return res;
            },
            () => {
                const result: any = [];
                result.total = 0;
                return result;
            },
        );
    }

    getLinksCount (): Promise<any> {
        const params = {
            page: 1,
            page_size: 1,
            page_fixed: false,
        };
        return this.linksRepoService.getAll(params).then(
            (res: any) => {
                return res;
            },
            () => {
                const result: any = [];
                result.total = 0;
                return result;
            },
        );
    }

    getPolicies (): Promise<any> {
        let chain = Promise.resolve();
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            scheduled: this.policyScheduled,
            search: this.search || null,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };
        if (this.activeTab) {
            params.mode = this.activeTab;
        }

        if (this.openSelectedPolicy > 0) {
            params.page_size = 100;
        }

        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }

        return this.policyRepoService.domainGetAll(params).then((policies: any[]) => {
            policies.forEach((policy: any) => {
                chain = chain.then(() => {
                    if (this.destroyed) {
                        return;
                    }
                    if (policy.pages_count === null || policy.links_count === null) {
                        if (policy.subject === 'link') {
                            return this.getPolicyLinkCount(policy);
                        } else {
                            return this.getPolicyPageCount(policy);
                        }
                    }
                    return;
                });
            });

            return chain.then(() => {
                if (this.destroyed) {
                    return;
                }

                if (this.openSelectedPolicy > 0) {
                    const policy = policies.find(p => p.id === parseInt(this.openSelectedPolicy));
                    this.openSelectedPolicy = null;
                    if (policy) {
                        this.policies = [policy];
                        if (policy.subject !== 'link') {
                            this.openPagesDialog(policy);
                        } else {
                            this.openLinksDialog(policy);
                        }
                    }
                } else {
                    this.policies = policies;
                }

                if (this.policyTableService.areAnyPoliciesRunning(policies) && this.timerPromise === null) {
                    this.startAutoReload();
                }

                this.updateDropdowns();
                this.getSubHeaderDescription();
            });
        }, () => {});
    }

    updateDropdowns (): void {
        for (const policy of this.policies) {
            const dropdown = [
                {
                    label: this.translateService.getString('Run Policy'),
                    leftIcon: 'faPlay',
                    action: () => {
                        const message = this.translateService.getString(
                            'Are you sure you want to run the policy <strong>[[policyName]]</strong>?',
                            { policyName: policy.name },
                        );
                        this.monModalService.confirm(message).then(() => this.runPolicy(policy));
                    },
                    eventParams: { action: 'policy-run', params: { name: policy.name } },
                    disabled: policy.state === 'running' || this.getDomainCrawlStatus(),
                    shouldShow: policy.state !== 'queued',
                },
                {
                    label: this.translateService.getString('Policy in queue'),
                    leftIcon: 'faPlay',
                    shouldShow: policy.state === 'queued',
                },
                {
                    label: this.translateService.getString('Show on global policy list'),
                    leftIcon: 'faGavel',
                    action: () => this.stateService.go('base.customer.global.policy.policies', { search: policy.name }),
                    eventParams: { action: 'go-to-global-policy-policy-list', from: 'domain-policy-policy-list', params: { name: policy.name } },
                    dataTestAttribute: 'policy-list',
                },
            ];

            policy.dropdown = dropdown.filter((option: any) => option.shouldShow !== false).map((item: any) => {
                return {
                    label: item.label,
                    leftIcon: item.leftIcon,
                    disabled: item.disabled,
                    action: () => {
                        if (item.eventParams) {
                            this.monEventsService.run('actionTrigger', item.eventParams);
                        }

                        item.action();
                    },
                    dataTestAttribute: item.dataTestAttribute,
                };
            });
        }
    }

    override getPage = (): void => {
        this.paramService.setParams({
            tab: this.activeTab,
        });
        this.destroyTimer();
        this.progress = this.getPolicies();
    };

    getSubHeaderDescription (): void {
        this.subheaderTranslation = this.translateService.getPlural(
            this.pipeService.get('monNumber')((this.policies as any).total, '0,0'),
            '1 policy found',
            '[[$count]] policies found',
            {},
            '',
        );
    }

    runPolicy (policy: any): void {
        this.policyService
            .run(policy.id)
            .then(() => {}, () => {})
            .finally(() => {
                this.getPage();
            });
    }

    openPagesDialog (policy: any): void {
        let count = 0;
        switch (policy.subject) {
            case 'page':
                count = this.allPagesCount;
                break;

            case 'page_html':
            case 'page_html_text':
                count = this.htmlCount;
                break;

            case 'page_document':
                count = this.documentCount;
                break;
        }
        this.destroyTimer();
        const params = {
            body: PagesPolicyDialogPagesComponent,
            size: 'lg',
            data: {
                policy: policy,
                pageCount: this.htmlCount,
                contentCount: count,
                pdfCount: this.pdfCount,
                documentCount: this.documentCount,
            },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: this.getPage });
    }

    openLinksDialog (policy: any): void {
        this.destroyTimer();
        const params = {
            body: PagesPolicyDialogLinksComponent,
            size: 'lg',
            data: { policy: policy },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: this.getPage });
    }

    openPolicyForm (): void {
        const params = {
            body: FormGlobalPolicyComponent,
            size: 'fw',
        };
        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: this.getPage });
    }

    getDomainCrawlStatus (): boolean {
        return this.sessionService.domain !== null && this.sessionService.domain.crawl_status !== null;
    }

    onFiltersChanges (changes: any): void {
        this.updateFilters(changes);
        this.updateCustomerFilters(changes);
        this.getPage();
    }

    updatePolicy (policy: any): void {
        const cPolicy: any = {};
        cPolicy.id = policy.id;
        cPolicy.labels = policy.labels.map((label: any) => {
            return label.id;
        });
        this.policyService.update(cPolicy).then(() => {}, () => {});
    }

    // PROTECTED

    updateCustomerFilters (changes: any): void {
        this.policyScheduled = null;
        if (changes.changes) {
            changes = changes.changes;
        }

        if (changes.scheduled && changes.scheduled.length > 0) {
            const schedule = changes.scheduled[changes.scheduled.length - 1];
            this.filters.scheduled = [schedule];
            this.policyScheduled = schedule.value;
        }
    }

    startAutoReload (): void {
        if (!this.destroyed) {
            this.timerPromise = setTimeout(() => {
                this.timerPromise = null;
                this.getPolicies();
            }, 30000);
        }
    }

    getPolicyLinkCount (policy: any): Promise<any> {
        const params = {
            page: 1,
            page_size: 1,
        };
        return this.policyRepoService.domainGetPolicyLinks(policy.id, params).then(
            (policies: any) => {
                policy.links_count = parseInt(policies.total, 10);
                policy.pages_count = 0;
                policy.matches_count = policy.links_count;
            },
            () => {
                policy.pages_count = 0;
                policy.links_count = 0;
                policy.matches_count = 0;
            },
        );
    }

    getPolicyPageCount (policy: any): Promise<any> {
        const params = {
            page: 1,
            page_size: 1,
        };
        return this.policyRepoService.domainGetPolicyPages(policy.id, params).then(
            (policies: any) => {
                policy.pages_count = parseInt(policies.total, 10);
                policy.links_count = 0;
                policy.matches_count = policy.pages_count;
            },
            () => {
                policy.pages_count = 0;
                policy.links_count = 0;
                policy.matches_count = 0;
            },
        );
    }

    getPolicyTarget (policy: any): any {
        return this.policyHelperService.getType(policy);
    }

    hasRun (policy: any): boolean {
        return this.policyTableService.targetHasRun(policy);
    }

    policyScanValid (policy: any): boolean {
        return this.policyTableService.policyScanValid(policy);
    }

    trackByPolicyId (index: number, policy: any): any {
        return policy.id;
    }

}
